import * as yup from 'yup';
import { InvestmentExperience } from '../../AccountOpening.meta';

export const investmentExperienceOpts = [
  {
    label: 'None',
    value: InvestmentExperience.None,
  },
  {
    label: 'Limited',
    value: InvestmentExperience.Limited,
  },
  {
    label: 'Good',
    value: InvestmentExperience.Good,
  },
  {
    label: 'Extensive',
    value: InvestmentExperience.Extensive,
  },
];

export const investmentExperienceValidation = yup
  .number()
  .nullable()
  .required('You need to specify your investment experience');
